import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BreadCrumb from 'src/Components/GlobalComponents/BreadCrumb';
import HomeCareAppointmentDetailComponent from 'src/Components/GlobalComponents/HomeCareAppointmentDetailComponent';

const AdminHomecareAppointmentDetail: React.FC = () => {
    const navigate = useNavigate();
    const { id = "" } = useParams();
    return (
        <>
            <BreadCrumb
                current="At-home Appointment"
                previous="dashboard"
                navigateUrl="/admin"
                btnShow={true}
                isUpsert={true}
                onPress={() => navigate("/admin/homecare-appointments")}
            />
            <div className="appointmen-new-ui-spacing-issue-resolve">
                <HomeCareAppointmentDetailComponent
                    appoinmentId={id}
                    userRole="admin"
                />
            </div>
        </>
    );
};

export default AdminHomecareAppointmentDetail;